// Exposes the CSS color tokens via Javascript
export const Color = {
  primary100: 'var(--color-primary-100)',
  primary200: 'var(--color-primary-200)',
  primary300: 'var(--color-primary-300)',
  primary400: 'var(--color-primary-400)',
  primary500: 'var(--color-primary-500)',
  primary600: 'var(--color-primary-600)',
  primary700: 'var(--color-primary-700)',
  primary800: 'var(--color-primary-800)',

  gold100: 'var(--color-gold-100)',
  gold200: 'var(--color-gold-200)',
  gold300: 'var(--color-gold-300)',
  gold400: 'var(--color-gold-400)',
  gold500: 'var(--color-gold-500)',
  gold600: 'var(--color-gold-600)',
  gold700: 'var(--color-gold-700)',
  gold800: 'var(--color-gold-800)',

  mono100: 'var(--color-mono-100)',
  mono200: 'var(--color-mono-200)',
  mono250: 'var(--color-mono-250)',
  mono300: 'var(--color-mono-300)',
  mono400: 'var(--color-mono-400)',
  mono500: 'var(--color-mono-500)',
  mono600: 'var(--color-mono-600)',
  mono700: 'var(--color-mono-700)',
  mono800: 'var(--color-mono-800)',

  pink100: 'var(--color-pink-100)',
  pink200: 'var(--color-pink-200)',
  pink300: 'var(--color-pink-300)',
  pink400: 'var(--color-pink-400)',
  pink500: 'var(--color-pink-500)',
  pink600: 'var(--color-pink-600)',
  pink700: 'var(--color-pink-700)',
  pink800: 'var(--color-pink-800)',

  red500: 'var(--color-red-500)',
  brown500: 'var(--color-brown-500)',
  blue300: 'var(--color-blue-300)',
  green300: 'var(--color-green-300)',
};
